
import i18n from '@/plugins/i18n'

export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Mochi Id",
          value: "mochiId",
        },
        {
          text: "Avatar",
          value: "avatar",
        },
      ],
    },
  },
   read: {
     tabs: [
       {
         key: "Info",
         label: i18n.t("string.info"),
       },
     ],
     table: {
       headers: [
          {
          text: "Mochi Id",
          value: "mochiId",
        },
        {
          text: "Avatar",
          value: "avatar",
        },
         {
           text: i18n.t("model.prop.created"),
           value: "timestampCreated",
           filterable: false,
         },
         {
           text: i18n.t("model.prop.lastUpdated"),
           value: "timestampUpdated",
           filterable: false,
         },
       ],
     },
   },
  add: true,
  edit: false,
  delete: true,
}